/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║  LOGO AUFKLEBER CONFIGURATOR ENGINE                         ║
 * ║  Production-grade state machine for 6-step product config   ║
 * ╚══════════════════════════════════════════════════════════════╝
 */
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        const root = document.getElementById('LogoConfigurator');
        if (!root) return;

        const parsePrice = (value) => {
            const n = parseInt(value, 10);
            return Number.isFinite(n) ? n : 0;
        };

        /* ═══ STATE ═══ */
        const state = {
            step: 1,
            maxSteps: 6,
            source: 'upload',
            shape: 'Rechteckig',
            width: 20,
            height: 20,
            area: 0.04,
            category: 'lt1',
            categoryLabel: '< 1 m²',
            placement: 'outside',
            finish: 'Glänzend',
            variantId: null,
            variantPrice: 0,
            logoDesign: false,
            handlingId: root.dataset.handlingId || '',
            serviceId: root.dataset.serviceId || '',
            prices: {
                handling: parsePrice(root.dataset.handlingPrice),
                service: parsePrice(root.dataset.servicePrice)
            }
        };

        /* ═══ DOM REFS ═══ */
        const $ = (s) => root.querySelector(s);
        const $$ = (s) => root.querySelectorAll(s);

        const dom = {
            title: $('#LacTitle'),
            hint: $('#LacHint'),
            dots: $$('.lac__step-dot'),
            lines: $$('.lac__step-line'),
            steps: $$('.lac__step'),
            next: $('#LacNext'),
            prev: $('#LacPrev'),

            uploadPanel: $('#LacUploadPanel'),
            designPanel: $('#LacDesignPanel'),
            fileInput: $('#LacFileInput'),
            dropzone: $('#LacDropzone'),

            sizeGridRect: $('#LacSizeGridRect'),
            sizeGridRound: $('#LacSizeGridRound'),
            widthInput: $('#LacWidth'),
            heightInput: $('#LacHeight'),
            diameterInput: $('#LacDiameter'),
            stepPriceDisplay: $('#LacStepPrice'),
            catPill: $('#LacCatPill'),

            summary: $('#LacSummary'),
            priceBase: $('#LacPriceBase'),
            priceHandling: $('#LacPriceHandling'),
            priceDesign: $('#LacPriceDesignRow'),
            priceDesignValue: $('#LacPriceDesignValue'),
            priceTotal: $('#LacPriceTotal'),
            confirm: $('#LacConfirm'),

            stage: $('#LacStage'),
            galleryItems: $$('.lac__gallery-slide'),
            thumbnails: $$('.lac__thumb'),
            badgeSize: $('#LacBadgeSize'),
            badgeCat: $('#LacBadgeCat'),

            fvRoot: $('#LacFinishVisualizer'),
            fvImg: $('#LacFinishVisualizerImg'),
            fvLabel: $('#LacFinishVisualizerLabel'),

            variantMap: JSON.parse($('#LacVariantMap').textContent)
        };

        const TITLES = [
            'Schritt 1 — Logo Quelle',
            'Schritt 2 — Form wählen',
            'Schritt 3 — Maße eingeben',
            'Schritt 4 — Platzierung',
            'Schritt 5 — Oberfläche',
            'Schritt 6 — Zusammenfassung'
        ];

        const HINTS = [
            'Wählen Sie, wie Sie Ihr Logo bereitstellen möchten.',
            'Bestimmen Sie die Grundform Ihres neuen Aufklebers.',
            'Geben Sie die gewünschte Breite und Höhe in Zentimetern an.',
            'Wählen Sie, ob der Aufkleber von innen oder außen kleben soll.',
            'Wählen Sie die ideale Oberflächen-Veredelung für Ihr Logo.',
            'Überprüfen Sie Ihre Konfiguration vor dem Bestellen.'
        ];

        function fmt(cents) {
            return (cents / 100).toFixed(2).replace('.', ',') + ' €';
        }

        /* ═══ STEPPER ENGINE ═══ */
        function goTo(step) {
            if (step < 1 || step > state.maxSteps) return;
            state.step = step;
            renderStepper();
        }

        function renderStepper() {
            const s = state.step;

            dom.title.textContent = TITLES[s - 1];
            if (dom.hint) dom.hint.textContent = HINTS[s - 1];

            dom.dots.forEach((dot, i) => {
                const n = i + 1;
                dot.classList.toggle('is-active', n === s);
                dot.classList.toggle('is-done', n < s);
            });

            dom.lines.forEach((line, i) => {
                line.classList.toggle('is-done', i + 1 < s);
            });

            dom.steps.forEach(panel => {
                const vis = parseInt(panel.dataset.step, 10) === s;
                panel.classList.toggle('is-visible', vis);
            });

            dom.prev.classList.toggle('is-hidden', s === 1);

            if (s === state.maxSteps) {
                dom.next.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> In den Warenkorb';
                dom.next.classList.remove('lac__btn--primary');
                dom.next.classList.add('lac__btn--cart');
            } else {
                dom.next.innerHTML = 'Weiter <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';
                dom.next.classList.add('lac__btn--primary');
                dom.next.classList.remove('lac__btn--cart');
            }

            if (s === 3) recalculate();
            if (s === 6) renderFinalSummary();
        }

        /* ═══ CALCULATION ═══ */
        function recalculate() {
            const isRound = state.shape === 'Rund';

            if (dom.sizeGridRect) dom.sizeGridRect.classList.toggle('is-hidden', isRound);
            if (dom.sizeGridRound) dom.sizeGridRound.classList.toggle('is-hidden', !isRound);

            if (isRound) {
                const d = Math.max(20, parseFloat(dom.diameterInput.value) || 20);
                state.width = d;
                state.height = d;
            } else {
                state.width = Math.max(20, parseFloat(dom.widthInput.value) || 20);
                state.height = Math.max(20, parseFloat(dom.heightInput.value) || 20);
            }

            state.area = (state.width * state.height) / 10000;

            if (state.area < 1) {
                state.category = 'lt1';
                state.categoryLabel = '< 1 m²';
            } else if (state.area < 2) {
                state.category = '1-2';
                state.categoryLabel = '1 – 2 m²';
            } else {
                state.category = 'gte2';
                state.categoryLabel = '≥ 2 m²';
            }

            if (dom.catPill) dom.catPill.textContent = state.categoryLabel;
            if (dom.badgeSize) dom.badgeSize.textContent = isRound ? `Ø ${state.width} cm` : `${state.width} × ${state.height} cm`;
            if (dom.badgeCat) dom.badgeCat.textContent = state.categoryLabel;

            resolveVariant();

            const currentTotal = state.variantPrice + state.prices.handling;
            if (dom.stepPriceDisplay) {
                dom.stepPriceDisplay.textContent = fmt(currentTotal);
            }

            updatePreviewAspect();
        }

        function resolveVariant() {
            const key = state.shape.toLowerCase() + '_' + state.category;
            const match = dom.variantMap[key];

            if (!match) {
                state.variantId = null;
                state.variantPrice = 0;
                return;
            }

            state.variantId = match.id;

            if (state.shape === 'Rund') {
                if (state.area < 1) {
                    state.variantPrice = Math.round(10000 * state.area);
                } else if (state.area < 2) {
                    state.variantPrice = Math.round(7000 * state.area);
                } else {
                    state.variantPrice = Math.round(5000 * state.area);
                }
            } else {
                if (state.area < 1) {
                    state.variantPrice = Math.round(9000 * state.area);
                } else if (state.area < 2) {
                    state.variantPrice = Math.round(4500 * state.area);
                } else {
                    state.variantPrice = Math.round(4000 * state.area);
                }
            }
        }

        function updatePreviewAspect() {
            if (!dom.draggable) return;

            const ratio = state.width / state.height;
            let w = 50;
            let h = 50;

            if (ratio > 1) {
                w = 60;
                h = 60 / ratio;
            } else {
                h = 60;
                w = 60 * ratio;
            }

            dom.draggable.style.width = w + '%';
            dom.draggable.style.height = h + '%';
        }

        /* ═══ FINAL SUMMARY ═══ */
        function renderFinalSummary() {
            recalculate();

            const isRound = state.shape === 'Rund';
            const rows = [
                {
                    label: 'Quelle',
                    value: state.source === 'upload' ? 'Eigenes Logo' : `Design Service (${fmt(state.prices.service)})`
                },
                { label: 'Form', value: state.shape },
                { label: 'Maße', value: isRound ? `Ø ${state.width} cm` : `${state.width} × ${state.height} cm` },
                { label: 'Platzierung', value: state.placement === 'outside' ? 'Außen' : 'Innen (Spiegel)' },
                { label: 'Oberfläche', value: state.finish }
            ];

            dom.summary.innerHTML = rows.map(r =>
                `<div class="lac__summary-row"><span>${r.label}</span><strong>${r.value}</strong></div>`
            ).join('');

            const baseCents = state.variantPrice;
            const handCents = state.prices.handling;
            const designCents = state.source === 'design' ? state.prices.service : 0;
            const totalCents = baseCents + handCents + designCents;

            dom.priceBase.textContent = fmt(baseCents);

            if (dom.priceHandling) {
                dom.priceHandling.textContent = handCents > 0 ? fmt(handCents) : '–';
            }

            if (dom.priceDesignValue) {
                dom.priceDesignValue.textContent = designCents > 0 ? fmt(designCents) : '–';
            }

            dom.priceDesign.classList.toggle('is-hidden', state.source !== 'design');
            dom.priceTotal.textContent = fmt(totalCents);

            const propPrice = $('#LacPropPrice');
            if (propPrice) {
                propPrice.value = fmt(totalCents);
            }
        }

        /* ═══ CART SUBMISSION (Worker Flow: Upload → Draft Order) ═══ */
        async function addToCart() {
            if (!dom.confirm.checked) {
                shakeButton();
                return;
            }

            if (!state.variantId) {
                alert('Kein passender Variant gefunden. Bitte Maße eingeben.');
                return;
            }

            dom.next.disabled = true;
            const originalBtnHtml = dom.next.innerHTML;
            dom.next.innerHTML = '<span>Kasse wird vorbereitet...</span><div class="lac__spinner"></div>';

            try {
                let logoUrl = null;
                const file = dom.fileInput.files[0];

                if (state.source === 'upload' && file) {
                    try {
                        logoUrl = await uploadFileToWorker(file);
                    } catch (err) {
                        console.error('Upload error:', err);
                        alert('Fehler beim Hochladen des Logos: ' + err.message);
                        resetButton(originalBtnHtml);
                        return;
                    }
                }

                const totalCents = state.variantPrice + state.prices.handling + (state.source === 'design' ? state.prices.service : 0);
                const totalPriceEur = (totalCents / 100).toFixed(2);

                const isRound = state.shape === 'Rund';
                const sizeStr = isRound ? `Ø ${state.width} cm` : `${state.width} × ${state.height} cm`;

                const note = state.source === 'upload'
                    ? (root.querySelector('#LacNoteUpload')?.value || '')
                    : (root.querySelector('#LacNoteDesign')?.value || '');

                const properties = [
                    { name: 'Form', value: state.shape },
                    { name: 'Maße', value: sizeStr },
                    { name: 'Platzierung', value: state.placement === 'outside' ? 'Außen' : 'Innen (Spiegel)' },
                    { name: 'Oberfläche', value: state.finish },
                    {
                        name: 'Logo Quelle',
                        value: state.source === 'upload' ? 'Eigenes Logo' : `Designservice (${fmt(state.prices.service)})`
                    },
                    { name: 'Hinweis', value: note || 'Keine' }
                ];

                if (logoUrl) {
                    properties.push({ name: 'Logo Datei', value: logoUrl });
                }

                const payload = {
                    title: `Logo Aufkleber — ${state.shape} ${sizeStr}`,
                    price: totalPriceEur,
                    properties
                };

                const res = await fetch('https://iblaprint-proxy.alnmrwesam9.workers.dev/draft-order', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                if (!res.ok) {
                    const errText = await res.text().catch(() => '');
                    throw new Error(`Draft Order fehlgeschlagen (${res.status}): ${errText.slice(0, 200)}`);
                }

                const data = await res.json();

                if (data.invoice_url) {
                    window.location.href = data.invoice_url;
                } else {
                    throw new Error('Keine Checkout-URL erhalten. Worker-Antwort: ' + JSON.stringify(data));
                }
            } catch (e) {
                console.error('Checkout error:', e);
                alert('Fehler: ' + e.message);
                resetButton(originalBtnHtml);
            }
        }

        async function uploadFileToWorker(file) {
            const formData = new FormData();
            formData.append('file', file);

            const res = await fetch('https://iblaprint-upload.alnmrwesam9.workers.dev/', {
                method: 'POST',
                body: formData
            });

            const data = await res.json().catch(() => ({ ok: false, error: 'Ungültige Antwort vom Upload-Server' }));

            if (!res.ok || !data.ok) {
                throw new Error(data.error || `HTTP ${res.status}`);
            }

            return data.url || data.id || null;
        }

        function resetButton(html) {
            dom.next.disabled = false;
            dom.next.innerHTML = html;
        }

        function shakeButton() {
            dom.next.style.animation = 'none';
            void dom.next.offsetWidth;
            dom.next.style.animation = 'lacShake 0.4s ease';
        }

        /* ═══ EVENT BINDINGS ═══ */
        dom.next.addEventListener('click', () => {
            if (state.step < state.maxSteps) {
                goTo(state.step + 1);
            } else {
                addToCart();
            }
        });

        dom.prev.addEventListener('click', () => goTo(state.step - 1));

        $$('.lac__choice-card[data-source]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.lac__choice-card[data-source]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');

                state.source = card.dataset.source;
                state.logoDesign = state.source === 'design';

                dom.uploadPanel.classList.toggle('is-hidden', state.source !== 'upload');
                dom.designPanel.classList.toggle('is-hidden', state.source !== 'design');
            });
        });

        $$('.lac__choice-card[data-shape]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.lac__choice-card[data-shape]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');
                state.shape = card.dataset.shape;
                recalculate();
            });
        });

        [dom.widthInput, dom.heightInput, dom.diameterInput].forEach(inp => {
            if (inp) inp.addEventListener('input', recalculate);
        });

        $$('.lac__choice-card[data-placement]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.lac__choice-card[data-placement]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');
                state.placement = card.dataset.placement;
            });
        });

        $$('.lac__choice-card[data-finish]').forEach(card => {
            card.addEventListener('click', () => {
                $$('.lac__choice-card[data-finish]').forEach(c => c.classList.remove('is-selected'));
                card.classList.add('is-selected');
                state.finish = card.dataset.finish;
            });

            card.addEventListener('mouseenter', () => {
                const previewUrl = card.dataset.preview;
                const label = card.dataset.finish;

                if (previewUrl && dom.fvRoot) {
                    dom.fvImg.src = previewUrl;
                    dom.fvLabel.textContent = label;
                    dom.fvRoot.classList.add('is-visible');
                }
            });

            card.addEventListener('mouseleave', () => {
                if (dom.fvRoot) {
                    dom.fvRoot.classList.remove('is-visible');
                }
            });
        });

        dom.thumbnails.forEach(thumb => {
            thumb.addEventListener('click', () => {
                const targetId = thumb.dataset.targetId;

                dom.thumbnails.forEach(t => t.classList.remove('is-active'));
                thumb.classList.add('is-active');

                dom.galleryItems.forEach(slide => {
                    slide.classList.toggle('is-active', slide.dataset.mediaId === targetId);
                });
            });
        });

        dom.fileInput.addEventListener('change', e => {
            const file = e.target.files[0];
            if (!file) return;
        });

        dom.dropzone.addEventListener('dragover', e => {
            e.preventDefault();
            dom.dropzone.classList.add('is-dragover');
        });

        dom.dropzone.addEventListener('dragleave', () => {
            dom.dropzone.classList.remove('is-dragover');
        });

        dom.dropzone.addEventListener('drop', e => {
            e.preventDefault();
            dom.dropzone.classList.remove('is-dragover');

            if (e.dataTransfer.files.length) {
                dom.fileInput.files = e.dataTransfer.files;
                dom.fileInput.dispatchEvent(new Event('change'));
            }
        });

        recalculate();
        renderStepper();
    }
})();